import PubSub from "pubsub-js";

var ContentSidebarLinks = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ContentSidebarLinks',
	};

	$.extend(true, this.options, options);

};

ContentSidebarLinks.prototype.init = function() {

	var self = this;

	// right side text
	this.positionRightSideText();

	$(window).on('load', function() {
		self.positionRightSideText();
	});

	PubSub.subscribe("resized", function(){
		self.positionRightSideText();
	});

};

ContentSidebarLinks.prototype.positionRightSideText = function() {

	var self = this;

	var $rightSideText = this.options.$el.find(`.${self.options.baseClass}__rightSideText`);
	var $contentWrapper = this.options.$el;

	var rightSideTextHeight = $rightSideText.outerWidth(); // element is rotated via css so width is actually height
	var rightSideTextWidth = $rightSideText.outerHeight(); // element is rotated via css so height is actually width

	var contentWrapperHeight = $contentWrapper.outerHeight();
	var contentWrapperWidth = $contentWrapper.width();

	// top
	var newTop = (contentWrapperHeight / 2) - (rightSideTextHeight / 2);
	$rightSideText.css('top', newTop);

	// right
	// pull right by negative height to align with right edge, then move away by 4% width
	// pulling right by negative height aligns with right edge because we're using transform-origin: 0px 0px
	// which means we pull right by negative height (which is width before our transform), and then
	// we swing the item down 90 degrees by it's top left edge
	var newRight = (rightSideTextHeight * -1) + (contentWrapperWidth * 0.04); 
	$rightSideText.css('right', newRight);

};

export default ContentSidebarLinks;
